<div class="component">
  <div class="wrapper">
    <div class="chart">
      <muni-gameday-bar-chart
        [config]="config"
        [data]="chartData | async"
        data-automation-e2e-selector="trancheChartSet"
      >
      </muni-gameday-bar-chart>
    </div>
    <div class="info" *ngIf="!!source">
      <div class="column">
        <dl data-automation-e2e-selector="series">
          <dt data-automation-e2e-selector="name">Series</dt>
          <dd data-automation-e2e-selector="value">
            <span
              *ngFor="let code of source.series; let $last = last"
              [textContent]="getCommaSeparatedValues(code, $last)"
            ></span>
          </dd>
        </dl>
        <dl data-automation-e2e-selector="orders">
          <dt data-automation-e2e-selector="name">Orders ($M)</dt>
          <dd
            [textContent]="source.ordersAmount | number"
            data-automation-e2e-selector="value"
          ></dd>
        </dl>
        <dl data-automation-e2e-selector="coupon">
          <dt data-automation-e2e-selector="name">Coupon</dt>
          <dd>
            <span
              data-automation-e2e-selector="value"
              [textContent]="source.coupons | iexRange: 'percent'"
            ></span>
          </dd>
        </dl>
      </div>
      <div class="column">
        <dl data-automation-e2e-selector="par">
          <dt data-automation-e2e-selector="name">Par ($M)</dt>
          <dd
            [textContent]="source.parAmount | number"
            data-automation-e2e-selector="value"
          ></dd>
        </dl>
        <dl
          *ngIf="source.subscription < 1"
          data-automation-e2e-selector="balance"
        >
          <dt data-automation-e2e-selector="name">Balance ($M)</dt>
          <dd
            [textContent]="source.balance | number"
            class="balanceValue"
            data-automation-e2e-selector="value"
          ></dd>
        </dl>
        <dl
          *ngIf="source.subscription >= 1"
          data-automation-e2e-selector="subscription"
        >
          <dt data-automation-e2e-selector="name">Subscription</dt>
          <dd
            [textContent]="subscriptionFormatter(source.subscription)"
            data-automation-e2e-selector="value"
          ></dd>
        </dl>
        <dl data-automation-e2e-selector="yieldPrice">
          <dt data-automation-e2e-selector="name">Yield/Price</dt>
          <dd>
            <span
              data-automation-e2e-selector="value"
              [textContent]="source.yieldPrices | iexRange: 'percent':'none'"
            ></span>
          </dd>
        </dl>
      </div>
      <dl
        data-automation-e2e-selector="callFeature"
        *ngIf="!!source.callFeatures[0]"
      >
        <dt data-automation-e2e-selector="name">Call Feature</dt>
        <dd title="{{ source.callFeatures.join(', ') }}" class="ellipsis">
          <div>
            <p
              [textContent]="
                source.callFeatures.length > 1
                  ? 'Multiple'
                  : source.callFeatures[0]
              "
              class="dynamic-ellipsis-text"
              data-automation-e2e-selector="value"
            ></p>
          </div>
        </dd>
      </dl>
      <dl data-automation-e2e-selector="insurance">
        <dt data-automation-e2e-selector="name">Insurance</dt>
        <dd title="{{ source.insurers.join(', ') }}" class="ellipsis">
          <div>
            <p
              [textContent]="
                source.insurers.length === 0
                  ? 'none'
                  : source.insurers.join(', ')
              "
              class="dynamic-ellipsis-text"
              data-automation-e2e-selector="value"
            ></p>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</div>
